const logoType = {
    LOGO : 0,
    LETTERHEAD : 1,
    AUTOMATION_ICON : 2,
    CUSTOM_ICON : 3,
    POWERED_BY_LOGO : 4,
    CARRIER_LOGO : 5,
    LOGO_HTML_LOGIN : 6,
    LOGO_HTML_UNDERWRITER_HEADER : 7,
    LOGO_HTML_AGENT_HEADER : 8
};

angular.module('gw-um-j2js')
    .constant('logoType', logoType);